var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightUpSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.5C7.5 1.03516 7.88281 0.625 8.375 0.625H11.8477C11.9844 0.625 12.0938 0.652344 12.2031 0.707031C12.2852 0.734375 12.3945 0.816406 12.4766 0.898438C12.6406 1.0625 12.7227 1.28125 12.75 1.5V5C12.75 5.49219 12.3398 5.875 11.875 5.875C11.3828 5.875 11 5.49219 11 5V3.63281L6.35156 8.25391C6.02344 8.60938 5.44922 8.60938 5.12109 8.25391C4.76562 7.92578 4.76562 7.35156 5.12109 7.02344L9.74219 2.375H8.375C7.88281 2.375 7.5 1.99219 7.5 1.5ZM0.5 3.25C0.5 2.29297 1.26562 1.5 2.25 1.5H4.875C5.33984 1.5 5.75 1.91016 5.75 2.375C5.75 2.86719 5.33984 3.25 4.875 3.25H2.25V11.125H10.125V8.5C10.125 8.03516 10.5078 7.625 11 7.625C11.4648 7.625 11.875 8.03516 11.875 8.5V11.125C11.875 12.1094 11.082 12.875 10.125 12.875H2.25C1.26562 12.875 0.5 12.1094 0.5 11.125V3.25Z",
    fill: "currenColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightUpSquare);
export default __webpack_public_path__ + "static/media/arrow-right-up-square.7f0f844c9fe386f00237b21b84cb6bc7.svg";
export { ForwardRef as ReactComponent };